module.exports = __webpack_public_path__ + "img/image48.21d72d46.png";